import toast from "react-hot-toast";
import { ReactComponent as EditIcon } from "../../../images/edit.svg";
import IconInput from "components/elements/IconInput";
import Table from "components/elements/Table";
const { default: dataProvider } = require("core/DataProvider");
const { default: Header } = require("../Header");
const { default: AddAccountManager } = require("./AddAccountManager");
const { useState, useEffect } = require("react");
const { useOutletContext } = require("react-router-dom");

const accountManagerHeaderMap = {
  action: "Actions",
  id: "ID",
  name: "Name",
  designation: "Designation",
  mobile: "Mobile",
  status: "Status",
  created_on: "CreatedOn",
  created_by: "CreatedBy",
  modified_on: "ModifiedOn",
  modified_by: "ModifiedBy",
};

const AccountManagers = props => {
  const { token } = useOutletContext();
  const { name, client_name } = token;

  const [accountManagers, setAccountManager] = useState([]);
  const [aloading, setALoading] = useState(false);
  const [editAM, setEditAM] = useState(null);
  const [asearch, setASearch] = useState("");

  const editAMUser = user => {
    setEditAM(user);
  };

  const editCancel = () => {
    setEditAM(null);
  };

  const fetchAccountManagers = async () => {
    try {
      let data = await dataProvider.network.get("masters/account-manager");
      let ams = [];

      for (let i = 0; i < data.length; i++) {
        data[i].created_on = data[i].created_on
          ? new Date(data[i].created_on).toLocaleString()
          : "";
        data[i].modified_on = data[i].modified_on
          ? new Date(data[i].modified_on).toLocaleString()
          : "";

        data[i].action = (
          <div
            className="action flex flex-v-center"
            onClick={() => {
              editAMUser(data[i]);
            }}
          >
            <div className="action-button flex flex-center">
              <EditIcon />
            </div>
          </div>
        );

        ams.push(data[i]);
      }

      setAccountManager(ams);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load account managers");
    } finally {
      setALoading(false);
    }
  };

  useEffect(() => {
    fetchAccountManagers();
  }, []);

  return (
    <div id="account-manager" className="page">
      <Header user={name} client_name={client_name} title="Account Managers" />
      <section className="account-manager-container">
        <AddAccountManager
          onComplete={() => fetchAccountManagers()}
          editUser={editAM}
          cancel={editCancel}
        />
        <div className="box mtop">
          <div className="flex flex-v-center">
            <h3 className="pad-lr">Account Managers</h3>
            <div className="right flex">
              <div className="el">
                {aloading && (
                  <div className="loader">
                    <div className="lds-hourglass"></div>
                  </div>
                )}
              </div>
              <div className="el pad-lr">
                <IconInput
                  value={asearch}
                  onChange={e => setASearch(e.target.value)}
                  placeholder="Search (min 3 character)"
                  icon="search"
                  style={{ minWidth: "250px" }}
                />
              </div>
            </div>
          </div>
          <div className="mtop">
            <Table
              headers={accountManagerHeaderMap}
              data={accountManagers}
              search={asearch}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default AccountManagers;
